import styled from 'styled-components'

export const Container = styled.div<{ loadingData: boolean }>`
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ loadingData }) => (loadingData ? 'default' : 'pointer')};
`
